export var WebhookDeliveryStatus;
(function (WebhookDeliveryStatus) {
    WebhookDeliveryStatus["PENDING"] = "PENDING";
    WebhookDeliveryStatus["SENDING"] = "SENDING";
    WebhookDeliveryStatus["FAILED"] = "FAILED";
    WebhookDeliveryStatus["SUCCESS"] = "SUCCESS";
    WebhookDeliveryStatus["DEAD"] = "DEAD";
})(WebhookDeliveryStatus || (WebhookDeliveryStatus = {}));
export class WebhookDelivery {
    id;
    subscriptionId;
    eventId;
    event;
    targetUrl;
    status;
    attemptCount;
    nextAttemptAt;
    lastAttemptAt;
    lastResponseStatus;
    lastError;
    createdAt;
    updatedAt;
}
//# sourceMappingURL=webhook-delivery.entity.js.map